// Sprint quellabhaengige Headline-Auswahl, Schritt 1 (nur Vorschau).
// Quelle wird einmal beim Laden bestimmt und nur im Arbeitsspeicher gehalten.
// Keine Browser-Speicherung, keine Besucher-ID. Auf Prod komplett inaktiv.

export const PREVIEW_HOST_SUFFIX = ".preview.emergentagent.com";

export function isCandidatePreviewHost(hostname) {
  return typeof hostname === "string" && hostname.toLowerCase().endsWith(PREVIEW_HOST_SUFFIX);
}

export function isPreviewRuntime() {
  return typeof window !== "undefined" && isCandidatePreviewHost(window.location.hostname);
}

const PAID_MEDIUMS = ["paid", "paid-social", "paid_social", "paidsocial", "cpc", "ppc", "ads", "ad"];
const EMAIL_SOURCES = ["kt", "klicktipp", "klick-tipp", "newsletter"];
const SOCIAL_SOURCES = ["fb", "facebook", "ig", "instagram", "meta"];
const SOCIAL_REF_HOSTS = ["facebook.com", "instagram.com"];
const AJ_SOURCES = ["aj_homepage", "aj-homepage", "ajhomepage"];
const AJ_REF_HOST = "effektiv-kommunizieren.de";

function refHost(referrer) {
  try {
    return new URL(referrer).hostname.toLowerCase();
  } catch {
    return "";
  }
}

const hostMatches = (host, domain) => host === domain || host.endsWith(`.${domain}`);

/** Reine Funktion: ordnet einen Besuch genau einer Quelle zu (Regel wird mitgeliefert). */
export function detectTrafficSource(search, referrer) {
  const p = new URLSearchParams(search || "");
  const src = (p.get("utm_source") || "").toLowerCase().trim();
  const med = (p.get("utm_medium") || "").toLowerCase().trim();
  const hasFbclid = !!p.get("fbclid");
  const host = refHost(referrer || "");

  if (med === "email" || EMAIL_SOURCES.includes(src)) return { source: "email", rule: "utm_email" };
  if (PAID_MEDIUMS.includes(med)) return { source: "paid_social", rule: "utm_paid_medium" };
  if (AJ_SOURCES.includes(src)) return { source: "aj_homepage", rule: "utm_aj" };
  if (SOCIAL_SOURCES.includes(src) || med === "social" || med === "organic-social" || med === "organic_social") {
    if (!med && hasFbclid) return { source: "direct", rule: "social_ambiguous_fbclid" };
    return { source: "organic_social", rule: "utm_social" };
  }
  if (src || med) return { source: "direct", rule: "utm_unknown" };
  if (SOCIAL_REF_HOSTS.some((d) => hostMatches(host, d))) {
    if (hasFbclid) return { source: "direct", rule: "social_ambiguous_fbclid" };
    return { source: "organic_social", rule: "referrer_social" };
  }
  if (hostMatches(host, AJ_REF_HOST) && !host.startsWith("flex4success.")) {
    return { source: "direct", rule: "referrer_aj_unbestaetigt" };
  }
  return { source: "direct", rule: host ? "referrer_other" : "none" };
}

// Erste Erkennung pro geoeffneter Seite, danach stabil (Arbeitsspeicher).
let memorySource = null;

export function getVisitSource() {
  if (memorySource) return memorySource;
  if (typeof window === "undefined") return { source: "direct", rule: "none" };
  memorySource = detectTrafficSource(window.location.search, document.referrer);
  return memorySource;
}

if (isPreviewRuntime()) getVisitSource();
